import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { getDamagedAdjusterOtherAttachedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterOtherAttachedImages/getDamagedAdjusterOtherAttachedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';
import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import { css } from 'styled-system/css';
import { ImagesListName } from '@/common/utils/ImagesListName';

const ShowDamagedOtherAttachedImagesTab = () => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedAdjusterOtherAttachedImagesQueryOptions({
      damaged_id: Number(damagedId),
      id: Number(id),
      type: 'adjuster',
    }),
  );
  if (!imagesData?.length) {
    return (
      <Box mt="100px">
        <EmptyImagesListIcon className={css({ mx: 'auto' })} />
      </Box>
    );
  }
  return (
    <>
      <Typography textStyle="b1" color="purple-1" my="24px">
        تصاویر زیان‌دیده
      </Typography>
      <Flex
        gap="1rem"
        maxWidth="maxContainer"
        margin="auto"
        mt="1.5rem"
        className={grid({ columns: 2 })}
      >
        {imagesData?.map((images, index) => {
          return (
            <ImageCard
              key={images.id}
              imageData={{
                name: ImagesListName({
                  titleType: 'attachment',
                  index,
                }),
                src: images.image,
              }}
            />
          );
        })}
      </Flex>
    </>
  );
};

export default ShowDamagedOtherAttachedImagesTab;
